import Vue from 'vue'

export default {
  list: async () => {
    return Vue.axios.get('/departments');
  },
  department: async (code) => {
    return Vue.axios.get('/departments/' + code);
  },
  save: async (department) => {
    let formData = new FormData()
    for (const field in department) if (department.hasOwnProperty(field)) {
      formData.append('department[' + field + ']', department[field])
    }
    return Vue.axios.post('/departments', formData);
  }
}
